import React from "react";

const PatientResultsTable = ({ patientRows, selectedPatientId, onSelectPatient, isCompact, showReferralHint }) => (
  <div className={`table-container apt-table track-patients-results${isCompact ? " is-compact" : ""}`}>
    <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
      <thead>
        <tr>
          <th>Fullname</th>
          <th>Practitioner</th>
          <th>DOB</th>
          <th>Gender</th>
          {showReferralHint && <th />}
        </tr>
      </thead>
      <tbody>
        {patientRows.length === 0 && (
          <tr>
            <td>No results</td>
          </tr>
        )}
        {patientRows.map((row) => (
          <tr
            key={row.patientId}
            className={`${row.patientId === selectedPatientId ? "is-active " : ""}is-hovered`}
            onClick={() => onSelectPatient(row.patientId)}
            title={showReferralHint ? "View referred specialists" : undefined}
          >
            <td>{row.fullname}</td>
            <td>{row.practitionerFullName}</td>
            <td>{row.dob}</td>
            <td>{row.gender}</td>
            {showReferralHint && (
              <td className="has-text-grey">
                <span className="icon is-small">
                  <i className="fas fa-chevron-right" />
                </span>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default PatientResultsTable;
